export default "__VITE_ASSET__Bdu97gpx__"